<template>
    <div>
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{trans('configuration.payment_configuration')}}</h3>
                    <div class="nk-block-des text-soft">
                        <p>{{ trans('configuration.payment_configuration') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="payment"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner admin-config-panel__inner--wide">
                    <div class="admin-linear-head">
                        <div>
                            <span class="admin-linear-head__eyebrow">Payment settings</span>
                            <h4 class="admin-linear-head__title">{{trans('configuration.payment_configuration')}}</h4>
                            <p class="admin-linear-head__description">Enable subscription gateways, configure credentials, and maintain invoice numbering from one guarded settings flow.</p>
                        </div>
                        <div class="admin-linear-stats">
                            <div>
                                <span>Gateways</span>
                                <strong>{{ enabledGatewayCount }}/4</strong>
                            </div>
                            <div>
                                <span>{{trans('configuration.invoice_configuration')}}</span>
                                <strong>{{ configForm.subscription_invoice_prefix || '-' }}</strong>
                            </div>
                        </div>
                    </div>
                    <form @submit.prevent="submit" @keydown="configForm.errors.clear($event.target.name)">
                        <section class="admin-config-section" :aria-label="trans('configuration.payment_configuration')">
                            <div class="admin-linear-section-label">Gateway command</div>
                            <h4 class="admin-config-section__title">{{trans('configuration.payment_configuration')}}</h4>
                            <p class="admin-config-section__description">Enable only the gateways you operate. Client secrets and private keys should match the selected live or test mode.</p>
                                <div class="row admin-linear-gateway-grid">
                                    <div class="col-12 col-lg-6 col-xl-3">
                                        <div class="admin-linear-gateway-card">
                                        <div class="form-group">
                                            <label for="">Paypal</label>
                                            <div>
                                                <switches class="" v-model="configForm.subscription_paypal" name="subscription_paypal" theme="bootstrap" color="success"></switches>
                                            </div>
                                        </div>
                                        <div v-if="configForm.subscription_paypal">
                                            <div class="form-group">
                                                <label for="">Paypal Mode</label>
                                                <div>
                                                    <switches class="" v-model="configForm.subscription_paypal_mode" name="subscription_paypal_mode" theme="bootstrap" color="success"></switches>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Paypal Client Id</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_paypal_client_id" name="subscription_paypal_client_id" placeholder="Paypal Client Id">
                                                <show-error :form-name="configForm" prop-name="subscription_paypal_client_id"></show-error>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Paypal Client Secret</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_paypal_client_secret" name="subscription_paypal_client_secret" placeholder="Paypal Client Secret">
                                                <show-error :form-name="configForm" prop-name="subscription_paypal_client_secret"></show-error>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 col-xl-3">
                                        <div class="admin-linear-gateway-card">
                                        <div class="form-group">
                                            <label for="">Stripe</label>
                                            <div>
                                                <switches class="" v-model="configForm.subscription_stripe" name="subscription_stripe" theme="bootstrap" color="success"></switches>
                                            </div>
                                        </div>
                                        <div v-if="configForm.subscription_stripe">
                                            <div class="form-group">
                                                <label for="">Stripe Mode</label>
                                                <div>
                                                    <switches class="" v-model="configForm.subscription_stripe_mode" name="subscription_stripe_mode" theme="bootstrap" color="success"></switches>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Stripe Publishable Key</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_stripe_publishable_key" name="subscription_stripe_publishable_key" placeholder="Stripe Publishable Key">
                                                <show-error :form-name="configForm" prop-name="subscription_stripe_publishable_key"></show-error>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Stripe Private Key</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_stripe_private_key" name="subscription_stripe_private_key" placeholder="Stripe Private Key">
                                                <show-error :form-name="configForm" prop-name="subscription_stripe_private_key"></show-error>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 col-xl-3">
                                        <div class="admin-linear-gateway-card">
                                        <div class="form-group">
                                            <label for="">Razorpay</label>
                                            <div>
                                                <switches class="" v-model="configForm.subscription_razorpay" name="subscription_razorpay" theme="bootstrap" color="success"></switches>
                                            </div>
                                        </div>
                                        <div v-if="configForm.subscription_razorpay">
                                            <div class="form-group">
                                                <label for="">Razorpay Mode</label>
                                                <div>
                                                    <switches class="" v-model="configForm.subscription_razorpay_mode" name="subscription_razorpay_mode" theme="bootstrap" color="success"></switches>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Razorpay Publishable Key</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_razorpay_publishable_key" name="subscription_razorpay_publishable_key" placeholder="Razorpay Publishable Key">
                                                <show-error :form-name="configForm" prop-name="subscription_razorpay_publishable_key"></show-error>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Razorpay Private Key</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_razorpay_private_key" name="subscription_razorpay_private_key" placeholder="Razorpay Private Key">
                                                <show-error :form-name="configForm" prop-name="subscription_razorpay_private_key"></show-error>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 col-xl-3">
                                        <div class="admin-linear-gateway-card">
                                        <div class="form-group">
                                            <label for="">Two Checkout</label>
                                            <div>
                                                <switches class="" v-model="configForm.subscription_two_checkout" name="subscription_two_checkout" theme="bootstrap" color="success"></switches>
                                            </div>
                                        </div>
                                        <div v-if="configForm.subscription_two_checkout">
                                            <div class="form-group">
                                                <label for="">Two Checkout Mode</label>
                                                <div>
                                                    <switches class="" v-model="configForm.subscription_two_checkout_mode" name="subscription_two_checkout_mode" theme="bootstrap" color="success"></switches>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Two Checkout Seller Id</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_two_checkout_seller_id" name="subscription_two_checkout_seller_id" placeholder="Two Checkout Seller Id">
                                                <show-error :form-name="configForm" prop-name="subscription_two_checkout_seller_id"></show-error>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Two Checkout Publishable Key</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_two_checkout_publishable_key" name="subscription_two_checkout_publishable_key" placeholder="Two Checkout Publishable Key">
                                                <show-error :form-name="configForm" prop-name="subscription_two_checkout_publishable_key"></show-error>
                                            </div>
                                            <div class="form-group">
                                                <label for="">Two Checkout Private Key</label>
                                                <input class="form-control" type="text" v-model="configForm.subscription_two_checkout_private_key" name="subscription_two_checkout_private_key" placeholder="Two Checkout Private Key">
                                                <show-error :form-name="configForm" prop-name="subscription_two_checkout_private_key"></show-error>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                        </section>
                        <section class="admin-config-section" :aria-label="trans('configuration.invoice_configuration')">
                            <div class="admin-linear-section-label">Invoice command</div>
                            <h4 class="admin-config-section__title">{{trans('configuration.invoice_configuration')}}</h4>
                            <p class="admin-config-section__description">Invoice numbering affects new subscription invoices and should be changed with care.</p>
                            <div class="row">
                                <div class="col-12 col-sm-4">
                                    <div class="form-group">
                                        <label for="">{{trans('configuration.subscription_invoice_prefix')}}</label>
                                        <input class="form-control" type="text" v-model="configForm.subscription_invoice_prefix" name="subscription_invoice_prefix" :placeholder="trans('configuration.subscription_invoice_prefix')">
                                        <show-error :form-name="configForm" prop-name="subscription_invoice_prefix"></show-error>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <div class="form-group">
                                        <label for="">{{trans('configuration.subscription_invoice_number_digit')}}</label>
                                        <input class="form-control" type="text" v-model="configForm.subscription_invoice_number_digit" name="subscription_invoice_number_digit" :placeholder="trans('configuration.subscription_invoice_number_digit')">
                                        <show-error :form-name="configForm" prop-name="subscription_invoice_number_digit"></show-error>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <div class="form-group">
                                        <label for="">{{trans('configuration.subscription_invoice_start_number')}}</label>
                                        <input class="form-control" type="text" v-model="configForm.subscription_invoice_start_number" name="subscription_invoice_start_number" :placeholder="trans('configuration.subscription_invoice_start_number')">
                                        <show-error :form-name="configForm" prop-name="subscription_invoice_start_number"></show-error>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="">{{trans('configuration.subscription_invoice_tnc')}}</label>
                                <html-editor name="subscription_invoice_tnc" :model.sync="configForm.subscription_invoice_tnc" :isUpdate="updateTnc" @clearErrors="configForm.errors.clear('subscription_invoice_tnc')"></html-editor>
                                <show-error :form-name="configForm" prop-name="subscription_invoice_tnc"></show-error>
                            </div>
                        </section>
                        <div class="admin-config-actions">
                            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('general.save')}}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'
    import switches from 'vue-switches'
    import htmlEditor from '../../../components/html-editor'

    export default {
        components : { configurationSidebar,switches,htmlEditor },
        data() {
            return {
                configForm: new Form({
                    config_type: '',
                    subscription_paypal: 0,
                    subscription_stripe: 0,
                    subscription_razorpay: 0,
                    subscription_two_checkout: 0,
                    subscription_paypal_mode: 0,
                    subscription_stripe_mode: 0,
                    subscription_razorpay_mode: 0,
                    subscription_two_checkout_mode: 0,
                    subscription_paypal_client_id: '',
                    subscription_paypal_client_secret: '',
                    subscription_stripe_publishable_key: '',
                    subscription_stripe_private_key: '',
                    subscription_razorpay_publishable_key: '',
                    subscription_razorpay_private_key: '',
                    subscription_two_checkout_seller_id: '',
                    subscription_two_checkout_publishable_key: '',
                    subscription_two_checkout_private_key: '',
                    subscription_invoice_tnc: '',
                    subscription_invoice_prefix: '',
                    subscription_invoice_number_digit: '',
                    subscription_invoice_start_number: ''
                },false),
                updateTnc: false
            }
        },
        computed: {
            enabledGatewayCount() {
                return [
                    this.configForm.subscription_paypal,
                    this.configForm.subscription_stripe,
                    this.configForm.subscription_razorpay,
                    this.configForm.subscription_two_checkout
                ].filter(Boolean).length;
            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            axios.get('/api/configuration')
                .then(response => response.data)
                .then(response => {
                    this.configForm = helper.formAssign(this.configForm, response);
                    this.updateTnc = true;
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                });
        },
        methods: {
            submit(){
                this.configForm.config_type = 'payment_gateway';
                this.configForm.subscription_paypal = (this.configForm.subscription_paypal) ? 1 : 0;
                this.configForm.subscription_stripe = (this.configForm.subscription_stripe) ? 1 : 0;
                this.configForm.subscription_razorpay = (this.configForm.subscription_razorpay) ? 1 : 0;
                this.configForm.subscription_two_checkout = (this.configForm.subscription_two_checkout) ? 1 : 0;
                this.configForm.subscription_paypal_mode = (this.configForm.subscription_paypal_mode) ? 1 : 0;
                this.configForm.subscription_stripe_mode = (this.configForm.subscription_stripe_mode) ? 1 : 0;
                this.configForm.subscription_razorpay_mode = (this.configForm.subscription_razorpay_mode) ? 1 : 0;
                this.configForm.subscription_two_checkout_mode = (this.configForm.subscription_two_checkout_mode) ? 1 : 0;
                this.configForm.post('/api/configuration')
                    .then(response => {
                        this.$store.dispatch('setConfig',this.configForm);
                        toastr.success(response.message);
                    }).catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.admin-linear-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
    padding: 1.1rem 1.2rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.06), var(--dash-pro-surface));
}

.admin-linear-head__eyebrow,
.admin-linear-section-label {
    display: block;
    color: var(--lms-primary);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.admin-linear-head__title {
    margin: 0.35rem 0 0;
    color: var(--dash-pro-text);
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.04em;
}

.admin-linear-head__description {
    max-width: 42rem;
    margin: 0.45rem 0 0;
    color: var(--dash-pro-muted);
    font-size: 0.875rem;
    line-height: 1.55;
}

.admin-linear-stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(7rem, 1fr));
    min-width: 18rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: var(--dash-pro-surface);
}

.admin-linear-stats > div {
    min-width: 0;
    padding: 0.85rem 1rem;
    border-right: 1px solid var(--dash-pro-border);
}

.admin-linear-stats > div:last-child {
    border-right: 0;
}

.admin-linear-stats span {
    display: block;
    color: var(--dash-pro-muted);
    font-size: 0.72rem;
    font-weight: 700;
}

.admin-linear-stats strong {
    display: block;
    overflow: hidden;
    margin-top: 0.25rem;
    color: var(--dash-pro-text);
    font-size: 1.1rem;
    letter-spacing: -0.04em;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.admin-linear-section-label {
    margin-bottom: 0.35rem;
}

.admin-linear-gateway-grid {
    margin-bottom: -1rem;
}

.admin-linear-gateway-grid > [class*="col-"] {
    margin-bottom: 1rem;
}

.admin-linear-gateway-card {
    height: 100%;
    padding: 1rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: var(--dash-pro-bg);
}

.admin-linear-gateway-card .form-group:last-child {
    margin-bottom: 0;
}

@media (max-width: 767.98px) {
    .admin-linear-head {
        align-items: stretch;
        flex-direction: column;
    }

    .admin-linear-stats {
        min-width: 0;
    }
}

@media (max-width: 575.98px) {
    .admin-linear-stats {
        grid-template-columns: 1fr;
    }

    .admin-linear-stats > div {
        border-right: 0;
        border-bottom: 1px solid var(--dash-pro-border);
    }

    .admin-linear-stats > div:last-child {
        border-bottom: 0;
    }
}
</style>
